// extracted by mini-css-extract-plugin
module.exports = {"root":"_2h0tN","avatar":"_1V_YE"};